







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
declare var window: any;
@Component
export default class GDPR extends Vue {
  $wlToastr: any;
  private agreeTerms: boolean = false;
  private agreeReceiveEmail: boolean = this.marketingNotificationText.trim() ? false : true;
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }

  updateFlag() {
    this.$emit('gdpr', {
      marketingEmailFlag: this.agreeReceiveEmail,
      tosEmailFlag: this.agreeTerms,
    });
  }

  get applicationName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME');
  }

  get companyName() {
    return (
      vxm.configs.getGlobalConfigValue('COMPANY_NAME') || this.applicationName
    );
  }

  get marketingText() {
    return `Yes, ${
      this.companyName
    } can also contact me about future job opportunities.`;
  }
  
  get UserTOSAgreementText() {
    const customTOStext = vxm.users.getUserLang == 'fr'  ? 
    vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT_FR') 
    :vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT');
    if (customTOStext) return customTOStext
      .replace(/{companyName}/g, this.companyName)
      .replace(/{termsOfServiceURL}/g, this.termsOfServiceURL)
      .replace(/{privacyPolicyURL}/g, this.privacyPolicyURL);
    return this.$t('signup.terms.services', {
      termsOfServiceURL: this.termsOfServiceURL,
      privacyPolicyURL: this.privacyPolicyURL,
      companyName: this.companyName
    })
  }
  get marketingNotificationText() { 
    return vxm.jobs.BrandingInfo.SIGNUP_ADDITIONAL_CONSENT;
  }
}
